import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useManageResource } from "../../../services/Context/ManageResourceContext";
import { useLanguageRes } from "../../../services/Context/LanguageContext";
import { apiConst, resourceConst } from "../../../services/constant/constant";
import { ecnSession, isArray, isFeautureEnabled } from "../../../services/utils/validation";
import { serverGet } from "../../../middleware/http";
import ProgressContext from "../../../services/utils/progress";
import { useAccountSettings } from "../../../services/Context/AccSettingContext";

export default function ServiceWidget() {
    const [widgetTitle, setWidgetTitle] = useState(null);
    const [resourceAction, setResourceAction] = useState([]);
    const [labResourceAction, setLabResourceAction] = useState([]);
    const { accountModules } = useAccountSettings();

    const {
        resourceList,
        getCurrentResource,
        actionExists,
        getCurrentResourceAction,
    } = useManageResource();
    const { getLanguageContent } = useLanguageRes();

    useEffect(() => {
        const _serviceResource = getCurrentResource("5", "DSB");

        const _actions = getCurrentResourceAction("HW4", "DSB");
        const _labactions = getCurrentResourceAction("HW4", "LGT");

        const _title = _serviceResource?.find((item) => item?.code == "HW4")?.title;

        if (_title) {
            setWidgetTitle(_title);
        }

        setResourceAction(_actions);
        setLabResourceAction(_labactions);
    }, [resourceList]);

    return (
        <>
            {(actionExists(resourceAction, resourceConst?.actions.view) || (isFeautureEnabled(accountModules, "LCT") && isFeautureEnabled(accountModules, "ELI"))) && (
                <div className={`card border-0 p-2 w-100 mb-3`}>
                    <div className="card-body pb-0">
                        <h4>{widgetTitle}</h4>
                        <span
                            dangerouslySetInnerHTML={{ __html: getLanguageContent("woctke") }}
                        />
                    </div>
                    <div className="card-footer bg-white border-0 pb-3">
                        <GetStarted />
                    </div>
                </div>
            )}
        </>
    );
}

export const GetStarted = () => {
    const [resourceAction, setResourceAction] = useState([]);
    const [labResourceAction, setLabResourceAction] = useState([]);

    const { resourceList, getCurrentResourceAction, actionExists } =
        useManageResource();
    const { progParams } = useContext(ProgressContext);

    const { getLanguageContent } = useLanguageRes();
    const { extAppRedirectUrl, accountModules } = useAccountSettings();

    const navigate = useNavigate();

    const navigateService = async () => {
        try {
            progParams(true);

            ecnSession("clear");

            //Generate access code and redirect to external site 
            if (extAppRedirectUrl && extAppRedirectUrl.trim() != "") {

                const getAccessCode = await serverGet(apiConst.accessCode);
                const url = new URL(extAppRedirectUrl);
                url.searchParams.set("code", getAccessCode?.data);

                return window.location.href = url.toString();
            }

            const res = await serverGet(`${apiConst.getServiceType}?typeId=1`);

            if (res?.status == "1" && isArray(res?.data) && res?.data?.length == 1) {
                // Single service type skips the service list (which normally tags
                // the flow as manual), so mark it here — the intake wizard uses
                // workFlowType=="man" to recognise a Get Started flow (e.g. to
                // hide the Back arrow on the first intake step).
                ecnSession("man", "workFlowType");
                navigate(
                    `/service?serviceid=${res?.data[0].id}&service=${res?.data[0].code}`
                );
            } else {
                // Hand off the already-fetched list so /services doesn't re-fetch the
                // identical typeId=1 call a second time just to render what we just got.
                navigate("/services", {
                    state: res?.status == "1" && isArray(res?.data) ? { serviceTypeList: res.data } : undefined,
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            progParams(false);
        }
    };

    const navigateLabTest = async () => {
        try {
            progParams(true);
            ecnSession("clear");
            navigate("/lablocation");
        } catch (e) {
            console.error(e);
        } finally {
            progParams(false);
        }
    };

    useEffect(() => {
        const _actions = getCurrentResourceAction("HW4", "DSB");
        const _labactions = getCurrentResourceAction("HW4", "LGT");

        setLabResourceAction(_labactions);
        setResourceAction(_actions);
    }, [resourceList]);
    const urlSearchParams = new URLSearchParams(window.location.search);

    return (
        <>
            {actionExists(resourceAction, resourceConst?.actions.view) && isFeautureEnabled(accountModules, "GGT") && (
                <button
                    type="button"
                    className="btn btn-primary btn-lg m-2"
                    onClick={navigateService}
                >
                    {getLanguageContent("wocgts")}
                </button>
            )}

            {window.location.pathname != "/dashboard" && isFeautureEnabled(accountModules, "LCT") && isFeautureEnabled(accountModules, "ELI") && (
                <button
                    type="button"
                    className="btn btn-primary btn-lg ms-4"
                    onClick={navigateLabTest}
                >
                   {getLanguageContent("lbpltx")}
                </button>
            )}
        </>
    );
};
